import axios from '../http'
import {API} from "../const"
import {changeEnableWithholding} from '../../common/bus'

const api = API+'/pay';

const error = (name) => (e) => console.error(name + ':=>', e);

export function getPayInfo(orderNo, cb, fcb = error('getPayInfo')){
  axios.get(api, {params:{orderNo}}).then(d => {
    cb(d.data);
  }).catch(d => fcb(d));
}

export function getPay(orderNo, cb, fcb = error('getPayInfo')){
  axios.get(api + '/payInfo', {params:{orderNo}}).then(d => {
    cb(d.data);
  }).catch(d => fcb(d));
}

export function getVerificationCode( cb, fcb = error('getVerificationCode')){
  axios.get(api+"/verification-code",).then(d => {
    cb(d.data);
  }).catch(d => fcb(d));
}

/**
 * {
  "verificationCode": "",
  "orderCodes": [
    ""
  ]
}
 * @param {*} data
 * @param {*} cb
 * @param {*} fcb
 */
export function pay(data, cb, fcb = error('pay')) {
  axios.post(api, data).then(d => {
    cb(d.data);
  }).catch(d => fcb(d));
}

export function paidReminder(cb, fcb = error('paidReminder')) {
  axios.put(api+'/paidReminder').then(d => {
    cb(d.data);
  }).catch(d => fcb(d));
}

export function initEnableWithholding(){
  getEnableWithholding(d=>{
    changeEnableWithholding(d.enableWithholding)
  })
}

export function getEnableWithholding(cb, fcb = error('getEnableWithholding')) {
  axios.get(API + '/pay/withholding').then(response => {
    cb(response.data)
  }).catch(err => fcb(err));
}

export function openAutomaticDeduction(params,cb, fcb = error('openAutomaticDeduction')) {
  axios.patch(API + '/pay/enableWithholding?enableWithholding=' + params).then(response => cb(response.data.url)).catch(err => fcb(err));
}
